
export enum OptionType {
    RADIO = 'radio',
    CHECKBOX = 'checkbox',
    TEXT = 'text'
}

export interface ProductOptionInterface {
    id: number;
    name: string;
    label: string;
    accepted_values: string;
    default_value: string;
    price: number;
    type: OptionType;
    value?: string;
}

export default class ProductOption implements ProductOptionInterface {
    id: number;
    name: string;
    label: string;
    accepted_values: string;
    default_value: string;
    price: number;
    type: OptionType;
    value?: string;

    constructor(productOption: ProductOptionInterface) {
        this.id = productOption.id;
        this.name = productOption.name;
        this.label = productOption.label;
        this.accepted_values = productOption.accepted_values;
        this.default_value = productOption.default_value;
        this.type = productOption.type;
        this.price = productOption.price;
        if (productOption.value !== undefined) {
            this.value = productOption.value;
        }
    }

    public static createBatch(productOptions: ProductOptionInterface[]): ProductOption[] {
        let productOptionInstances = [];
        for (let index = 0; index < productOptions.length; index++) {
            productOptionInstances.push(new ProductOption(productOptions[index]));
        }
        return productOptionInstances;
    }

    get radioOptions() {
        return this.accepted_values.split('\n').map((labelValueStr: string) => {
            const labelValue = labelValueStr.split(':');
            return {
                value: labelValue[0],
                label: labelValue[1]
            };
        });
    }
}